import AppUtils from "../../../../Utils/utils"
import { getNextcommerceDisconnectUrl } from "../../../User/services"

const useNextcommerceDisconnect = () => {
  const disconnectNext = async (business_account_id) => {
    try {
      const response = await getNextcommerceDisconnectUrl(business_account_id)
      AppUtils.goLink(response.data)
      if (!response.ok || typeof response?.data !== "string") {
        return null
      }
    } catch (error) {
      return null
    }
  }

  return {
    disconnectNext
  }
}

export default useNextcommerceDisconnect
